import { render, staticRenderFns } from "./query-xd-id.vue?vue&type=template&id=4110d682&scoped=true"
import script from "./query-xd-id.vue?vue&type=script&lang=js"
export * from "./query-xd-id.vue?vue&type=script&lang=js"
import style0 from "./query-xd-id.vue?vue&type=style&index=0&id=4110d682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_bf339e0f7cd061f35bf078d2faee2298/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4110d682",
  null
  
)

export default component.exports